import { CloudVersion } from './cloudVersion';

class PlainManager {
    static isEntry(plain: CloudVersion): boolean {
        return plain === CloudVersion.Entry;
    }

    static isProfessional(plain: CloudVersion): boolean {
        return plain === CloudVersion.Professional;
    }

    static isBusiness(plain: CloudVersion): boolean {
        return plain === CloudVersion.Business;
    }

    static isEnterprise(plain: CloudVersion): boolean {
        return plain === CloudVersion.Enterprise;
    }
}

export default PlainManager;
